import React from 'react';
import { withAuth0 } from '@auth0/auth0-react';
import { logoutUserAction } from '../../actions';
import { connect } from 'react-redux';

class Logout extends React.Component {
  componentDidMount() {
    this.props.logoutUserAction();
    const { logout } = this.props.auth0;
    logout({ returnTo: process.env.REACT_APP_LOGOUT_REDIRECT });
  }

  render() {
    return null;
  }
}

export default connect(null, { logoutUserAction })(withAuth0(Logout));
